// React.js
import { FC, useState, useRef, useEffect, ReactNode } from 'react'
// Icons
import { Cross } from '@components/icons'
import Cross2 from '@components/icons/Cross2'
// Utils
import cn from 'clsx'
// Styles
import s from './TooltipV2.module.css'

interface TooltipV2Props {
  children: ReactNode
  content: ReactNode
  className?: string
  closeButtonPosition?: boolean
  buttonStyles?: boolean
  onClose?: () => void;
}

const TooltipV2: FC<TooltipV2Props> = ({ children, content, className, closeButtonPosition, buttonStyles, onClose  }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false)
  const tooltipRef = useRef<HTMLDivElement>(null)

  const handleToggleTooltip = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setIsTooltipVisible((prev) => !prev)
  }

  const handleCloseTooltip = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    if (onClose) {
      onClose()
    }
    setIsTooltipVisible(false)
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (
      tooltipRef.current &&
      !tooltipRef.current.contains(event.target as Node)
    ) {
      setIsTooltipVisible(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <>
      <div className={s.tooltipContainer} ref={tooltipRef}>
        <div onClick={handleToggleTooltip} className={s.tooltipTrigger}>
          {children}
        </div>
        {isTooltipVisible && (
          <div className={cn(buttonStyles ? s.tooltip2 : s.tooltip, className)}>
            {content}
            <button
              onClick={handleCloseTooltip}
              className={cn(
                s.closeButton,
                buttonStyles ? 'top-[0.8rem] right-4' : (closeButtonPosition ? 'top-[1.2rem] !right-16 sm:top-[2.5rem]' : 'top-4 right-4')
              )}
            >
              {buttonStyles ? <Cross2 width="23" height="23" /> : <Cross width="23" height="23" />}
            </button>
          </div>
        )}
      </div>
      {/* Backdrop filter for mobile */}
      {isTooltipVisible && !closeButtonPosition && (
        <div className="absolute w-full h-full top-0 left-0 backdrop-brightness-50 md:hidden" />
      )}
    </>
  )
}

export default TooltipV2
